/* Luxury header: toggles the frosted-glass state on scroll and measures the
   topbar so the sticky header can let it scroll away. */
(function () {
  var root = document.documentElement;
  var threshold = 2;
  var ticking = false;

  function measure() {
    var topbar = document.querySelector('#shopify-section-header .header__topbar');
    var h = topbar ? topbar.offsetHeight : 0;
    root.style.setProperty('--lux-topbar-h', h + 'px');
    threshold = h + 2;
  }

  function update() {
    ticking = false;
    var y = window.pageYOffset || root.scrollTop || 0;
    root.classList.toggle('lux-scrolled', y > threshold);
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  function init() {
    measure();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); update(); });
    window.addEventListener('load', function () { measure(); update(); });
  }

  /* Tell CSS when the footer is on screen, so the floating cart card can step aside. */
  function watchFooter() {
    var footer = document.querySelector('footer.footer');
    if (!footer || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      root.classList.toggle('lux-footer-in-view', entries[0].isIntersecting);
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' }).observe(footer);
  }

  if (document.readyState !== 'loading') { init(); watchFooter(); }
  else document.addEventListener('DOMContentLoaded', function () { init(); watchFooter(); });
})();
